module.exports = __webpack_public_path__ + "img/zhihu_logo.972f34a7.png";